module.exports = __webpack_public_path__ + "media/Glowkit-tutorial.e5b0eec7.mp4";